export const HYDRATE_USER_SUCCESS = "HYDRATE_USER_SUCCESS";
export const SESSION_ENDED = "SESSION_ENDED";
export const FIRST_USE_TEXT_RECEIVED = "FIRST_USE_TEXT_RECEIVED";
export const FIRST_USE_CONFIRMED = "FIRST_USE_CONFIRMED";
export const LOGOUT_PREVENTED = "LOGOUT_PREVENTED";
export const MANUAL_LOGOUT = "MANUAL_LOGOUT";
export const REFRESH_USER_SUCCESS = "REFRESH_USER_SUCCESS";
